var _CancellationTokenSource_timeoutables, _CancellationTokenSource_cancelledEvent, _CancellationTokenSource_cancelled;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import CancellationToken from './CancellationToken';
import SingleInvokeEvent from '../Events/SingleInvokeEvent';
export default class CancellationTokenSource {
    constructor(cancellationToken) {
        _CancellationTokenSource_timeoutables.set(this, []);
        _CancellationTokenSource_cancelledEvent.set(this, new SingleInvokeEvent());
        _CancellationTokenSource_cancelled.set(this, false);
        if (cancellationToken) {
            cancellationToken.onCancelled.addHandler(() => this.cancel());
        }
    }
    get isCancellationRequested() {
        return __classPrivateFieldGet(this, _CancellationTokenSource_cancelled, "f");
    }
    get token() {
        return new CancellationToken(__classPrivateFieldGet(this, _CancellationTokenSource_cancelledEvent, "f"));
    }
    cancel() {
        if (!__classPrivateFieldGet(this, _CancellationTokenSource_cancelled, "f")) {
            __classPrivateFieldSet(this, _CancellationTokenSource_cancelled, true, "f");
            __classPrivateFieldGet(this, _CancellationTokenSource_timeoutables, "f").forEach(timeoutHandle => clearTimeout(timeoutHandle));
            __classPrivateFieldGet(this, _CancellationTokenSource_cancelledEvent, "f").invoke(this, undefined);
        }
    }
    cancelAfter(msTimeout) {
        if (!__classPrivateFieldGet(this, _CancellationTokenSource_cancelled, "f")) {
            __classPrivateFieldGet(this, _CancellationTokenSource_timeoutables, "f").push(setTimeout(() => this.cancel(), msTimeout));
        }
    }
}
_CancellationTokenSource_timeoutables = new WeakMap(), _CancellationTokenSource_cancelledEvent = new WeakMap(), _CancellationTokenSource_cancelled = new WeakMap();
